import connect from "../../../shared/data-store/connect";
import { store } from "./DataStore";
import { html, render } from "lit-html";
import unsaferHTML from "@escapio/shared/unsaferHTML";
import { getTitle } from "@escapio/portal/components/favorites/get-title";

customElements.define(
	"esc-favorites-list-header-counter",
	class extends connect(HTMLElement, store) {
		update(state, store) {
			const count = store.sortedHotels.length;
			const renderedCount = `<strong>${count}</strong>`;
			const template = html`${unsaferHTML(getTitle(count, renderedCount))}`;
			render(template, this);
		}
	},
);
